// Build mode is used to show previews of routes to the current mouse position.
export const BUILD_MODE = 'build'

// Edit mode is used to edit the waypoints along the route.
export const EDIT_MODE = 'edit'

export const DEFAULT_SNAP_RADIUS = 1000

// Prevents too many requests to the API when previewing route changes.
export const DEFAULT_PREVIEW_THROTTLE_INTERVAL = 300

// Throttle the maximum straight line distance between preview waypoints.
// Previews are disabled when the distance exceeds this value.
export const MAX_PREVIEW_DISTANCE_KM = 800

// Any permissions that can be returned for a route
export const ROUTE_PERMISSIONS = Object.freeze({
  COPY: 'route.copy',
})
